
export function generateCaptionInstagramBV (post) {
  let caption = ''
  caption = post.titre + ' '
  caption = caption + insertFieldIntoCaption(post.ville, false)
  caption = caption + '\r\n' + insertFieldIntoCaption(post.surface_habitable, true, this.$t('posts.edit.surfaceHabitable') + ' : ', ' M²') + insertFieldIntoCaption(post.nb_pieces_logement, true, this.$t('posts.privateNote.PostNumberRoom') + ' : ')
  caption = caption + insertFieldIntoCaption(post.dpe_etiquette_conso, true, this.$t('posts.dpeTitle') + ' : ')
  caption = caption + '\r\n\r\n' + insertAdText()
  caption = caption.substr(0, 2200)

  return caption
}

export function insertFieldIntoCaption (field, addVirgule = true, before = null, after = null) {
  let result = ''
  if (addVirgule === true) {
    result = result + '\r\n'
  } else {
    result = result + ' '
  }
  if (field) {
    if (field && before != null && after == null) {
      return result + before + field
    } else if (field && before == null && after != null) {
      return result + field + after
    } else if (field && before != null && after != null) {
      return result + before + field + after
    }
    return result + field
  } else {
    return ''
  }
}

export function insertAdText (post) {
  if (post.texte_resume) {
    return post.texte_resume
  } else if (post.texte) {
    return post.texte
  }
}

export function urlIsValid (urlString) {
  let isValid = false
  try {
    const urlVideo = new URL(urlString)
    isValid = (
      ((urlVideo.protocol === 'http:') || (urlVideo.protocol === 'https:')) &&
      (urlVideo.hostname.indexOf('youtube') === -1) &&
      (urlVideo.hostname.indexOf('dailymotion') === -1)
    )
  } catch (_) {
  }
  return isValid
}

export function possedeVideo (post) {
  let hasVideo = false
  if (post && post.postVideoFileUrlCustom) {
    const keys = Object.keys(post.postVideoFileUrlCustom)
    let cpt = 0
    while (!hasVideo && (cpt < keys.length)) {
      const key = keys[cpt]
      hasVideo = post.postVideoFileUrlCustom[key] && (post.postVideoFileUrlCustom[key].length > 0)
      cpt++
    }
  }
  return hasVideo
}

export function possedeVideoUploadee (post) {
  const existAssets = post &&
        post.assets &&
        post.assets.VIDEO &&
        Object.values(post.assets.VIDEO).length > 0
  if (existAssets) {
    return true
  }
  return false
}

export function generateCronExpression (date) {
  const dateObj = new Date(date)
  return `${dateObj.getMinutes()} ${dateObj.getUTCHours()} ${dateObj.getUTCDate()} ${dateObj.getUTCMonth() + 1} *`
}
